// GoalPace (Domain/Money; was HomeViews.tsx's, HIERARCHY follow-up 8, BL-189): the month against the goal
// (gp.pace): what's in so far as a figure, against the goal and the working days gone; a bar to the goal
// with a mark where it should be by today; then the pace in words (ahead, behind, too early to tell, no
// goal set), by how much, where it's heading and what's still in review. In a chat, a way into Flowology.
// Reads only --pace-*; Figure, Meter, Label and Button read their own.
import type { GoalPaceProps } from '../../schemas.ts';
import type { ViewProps } from '../../host.ts';
import { day, money, plural } from '../../format.ts';
import { Figure } from '../Figures/Figures.tsx';
import { Label, type LabelKind } from '../Label/Label.tsx';
import { Meter } from '../Meter/Meter.tsx';
import { ViewAct } from '../view-act.tsx';
import './GoalPace.css';

/** gp.pace */
export function GoalPace({ data: p, host }: ViewProps<GoalPaceProps>) {
  const status: [string, LabelKind] =
    p.status === 'ahead'
      ? ['Ahead of pace', 'now']
      : p.status === 'behind'
        ? ['Behind pace', 'bad']
        : p.status === 'too_early'
          ? ['Too early to tell', 'muted']
          : ['No goal set', 'wait'];
  const target = p.targetCents;
  return (
    <article className="fl-pace" data-surface={host.surface} aria-label="The month against the goal">
      <Figure
        label={`${day(p.from).replace(/^\d+ /, '')} so far`}
        value={money(p.totalCents)}
        sub={
          target
            ? `of ${money(target)}, ${p.workingDaysElapsed} of ${p.workingDays} working days`
            : `${plural(p.jobCount, 'job')} invoiced`
        }
      />
      {target != null && target > 0 && (
        <div className="fl-pace__bar">
          <Meter
            value={p.totalCents}
            max={target}
            label="Revenue against the goal"
            state={p.status === 'behind' ? 'low' : 'ok'}
            marks={[{ at: p.expectedCents, label: 'Where it should be by today' }]}
          />
        </div>
      )}
      <p className="fl-pace__line">
        <Label kind={status[1]}>{status[0]}</Label>
        {p.deltaCents != null && p.status !== 'too_early' && ` by ${money(Math.abs(p.deltaCents))}`}
        {p.projectedCents != null && `. On course for ${money(p.projectedCents)}`}
        {p.provisionalCents > 0 && `, ${money(p.provisionalCents)} of it still in review`}.
      </p>
      {host.surface === 'chat' && (
        <div className="fl-pace__acts">
          <ViewAct surface="chat" onPress={() => host.open({ kind: 'numbers' })}>
            Open in Flowology
          </ViewAct>
        </div>
      )}
    </article>
  );
}
